/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CAM_TOPOGRAFIA_ITEM = {
  id: 'agro_topografia',
  screenId: 'agr-cam-topografia',
  label: 'Topografía',
  description: 'Relevamientos con dron por campo o zona, y visor 2D/3D del terreno.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá registrás cada vuelo o relevamiento topográfico de un campo o de una zona. Después subís el paquete del visor y lo abrís en una pestaña nueva (ortomosaico, relieve, pendientes, curvas y escurrimiento).',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Tiene que existir el campo (y la zona, si el vuelo es de una zona). El visor se muestra cuando esa topografía ya tiene los datos del vuelo.',
          'El equipo de drone entrega un ZIP con las carpetas tiles y data del visor. Ese es el archivo que hay que subir.',
        ],
      },
      {
        title: 'Lista',
        bullets: [
          'Elegí un campo. La zona es opcional: si no elegís zona ves las topografías de todo el campo, incluidas las de sus zonas.',
          'El botón + abre el alta.',
          'Columnas: nombre, fecha del relevamiento, lugar y si el visor ya tiene datos.',
          'Si dice Listo, tocá la fila para abrir el visor en una pestaña nueva.',
          'Si dice Sin datos, tocá la fila (o el ícono de subir) para cargar el ZIP del vuelo.',
          'Los íconos de la derecha sirven para subir datos, editar o eliminar.',
        ],
      },
      {
        title: 'Alta',
        fields: [
          {
            label: 'Campo / Zona',
            description: 'Dónde aplica el relevamiento. Sin zona queda asociado a todo el campo.',
          },
          {
            label: 'Nombre',
            description: 'Cómo lo vas a reconocer en la lista (por ejemplo el nombre del establecimiento y la fecha).',
          },
          {
            label: 'Fecha del relevamiento',
            description: 'Fecha del vuelo, si la tenés.',
          },
          {
            label: 'Notas',
            description: 'Comentarios libres.',
          },
        ],
        paragraphs: [
          'Al crear una topografía nueva se abre la ventana para subir el ZIP. Hasta que no lo cargues, en la lista figura como Sin datos.',
        ],
      },
      {
        title: 'Cargar datos del vuelo',
        fields: [
          {
            label: 'Paquete del vuelo (ZIP)',
            description:
              'Elegí el ZIP que incluye las carpetas tiles y data. Si la topografía ya tenía datos, el ZIP nuevo los reemplaza. Puede tardar un minuto en descomprimirse.',
          },
        ],
        paragraphs: [
          'Cuando termina la carga, tocá Abrir visor para verlo en una pestaña nueva.',
        ],
      },
      {
        title: 'Visor',
        paragraphs: [
          'Se abre en una pestaña nueva, a pantalla completa. Tiene las mismas capas que el visor del relevamiento: ortomosaico, satelital de referencia, relieve sombreado, pendientes, curvas de nivel, escurrimiento por lote, medición de distancia y área, y vista 3D con exageración vertical.',
          'Cerrar pestaña vuelve a dejar esa ventana. Si una topografía todavía no tiene datos del vuelo, el visor lo indica.',
        ],
      },
    ],
  },
}
